import useGetSubscriptionQuery from '@/v2/domains/Subscriptions/queries/useGetSubscriptionQuery.hook';

export function useTrialOrPaidText(
  { trialText, paidText }: { trialText: string; paidText: string } = {
    trialText: 'Your free trial has ended',
    paidText: 'Your subscription has expired',
  }
) {
  const { data: subscription } = useGetSubscriptionQuery();

  if (!subscription) {
    return '';
  }

  return subscription?.trial ? trialText : paidText;
}
